/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/services'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Select from 'react-select'
function Workflows({ data, handleChange, locations, locationsLoader }) {
  const Service = useAppServices()
  const { id, company_id, app_id } = useParams()
  const [location, setLocation] = useState(
    locations?.find((item) => item.value == data?.location_token?.location_id) || null
  )
  const [installAppWorkflow, setInstallAppWorkflow] = useState(
    data?.workflows?.installAppWorkflow || null
  )
  const [unInstallAppWorkflow, setUnInstallAppWorkflow] = useState(
    data?.workflows?.unInstallAppWorkflow || null
  )
  const [workflowLoading, setWorkflowLoading] = useState(false)
  const [workflows, setWorkflows] = useState([])
  const [locationToken, setLocationToken] = useState(data?.location_token || null)

  useEffect(async () => {
    setLocationToken(data?.location_token || null)
    setUnInstallAppWorkflow(data?.workflows?.unInstallAppWorkflow || null)
    setInstallAppWorkflow(data?.workflows?.installAppWorkflow || null)
    setLocation(locations?.find((item) => item.value == data?.location_token?.location_id) || null)
  }, [data, locations])
  useEffect(async () => {
    if (location?.value) {
      handleLocation(location)
      setUnInstallAppWorkflow(data?.workflows?.unInstallAppWorkflow || null)
      setInstallAppWorkflow(data?.workflows?.installAppWorkflow || null)
    }
  }, [location])
  const handleSubmit = async (e) => {
    e.preventDefault()
    const payload = {
      workflows: {
        installAppWorkflow: installAppWorkflow,
        unInstallAppWorkflow: unInstallAppWorkflow,
      },
      location_token: locationToken,
      _id: id,
    }
    const { response } = await Service.snapshot_onboarding.update({ payload })
    if (response) {
      handleChange()
    }
  }
  const handleLocation = async (location) => {
    setLocation(location)
    setWorkflowLoading(true)
    setInstallAppWorkflow(null)
    setUnInstallAppWorkflow(null)
    const { response } = await Service.snapshot_onboarding.get_workflows({
      query: `company_id=${company_id}&app_id=${app_id}&location_id=${location.value}`,
    })

    if (response) {
      setWorkflows(
        response?.data?.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      )
      setWorkflowLoading(false)
      setLocationToken(response.location_token)
    }
  }
  return (
    <Card id="workflow-management">
      <MDBox p={3}>
        <MDTypography variant="h5">Workflow Management</MDTypography>
      </MDBox>
      <MDBox component="form" onSubmit={handleSubmit} role="form" pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item md={12}>
            <MDBox mb={1} sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" display="block" gutterBottom>
                Select Location (for workflows)
              </MDTypography>
              <Select
                isDisabled={locationsLoader}
                isLoading={locationsLoader}
                options={locations}
                value={location}
                onChange={(e) => {
                  handleLocation(e)
                }}
              />
            </MDBox>
          </Grid>
          <Grid item md={12}>
            <MDBox mb={1} sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" display="block" gutterBottom>
                Select Workflow For App Install
              </MDTypography>
              <Select
                options={workflows}
                isLoading={workflowLoading}
                isDisabled={workflowLoading}
                value={installAppWorkflow}
                loadingMessage={'Please wait fetching workflows'}
                onChange={(e) => {
                  setInstallAppWorkflow(e)
                }}
              />
            </MDBox>
          </Grid>
          <Grid item md={12}>
            <MDBox mb={1} sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" display="block" gutterBottom>
                Select Workflow For App UnInstall
              </MDTypography>
              <Select
                options={workflows}
                isLoading={workflowLoading}
                isDisabled={workflowLoading}
                value={unInstallAppWorkflow}
                loadingMessage={'Please wait fetching workflows'}
                onChange={(e) => {
                  setUnInstallAppWorkflow(e)
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
          flexWrap="wrap"
          mt={3}
        >
          <MDBox ml="auto">
            <MDButton variant="gradient" color="dark" size="small" type="submit">
              save
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  )
}

export default Workflows
